<template>
   <base-section
  id="mc-cluskey"
  >
    <v-container>
    <base-section-heading
    title="McCluskey Thesis Award"
    color="secondary"
    align="left"
    :toColor="true"
    >
    The TTTC’s Doctoral Thesis Award serves the purpose of promoting the most impactful doctoral student work, providing the students with exposure to the community and prospective employers, and supporting interaction between academia and industry in the field of test technology. The award is named after Prof. E. J. McCluskey, a key contributor to test technology. The 2025 TTTC’s E. J. McCluskey Best Doctoral Thesis Award will be given to the winning student of the doctoral student contest and their advisor.
      <br><br>The contest is held in two stages: semi-finals and finals.  In 2025, semi-finals will be held at the IEEE VLSI Test Symposium (VTS), the IEEE European Test Symposium (ETS), the IEEE Latin American Test Symposium (LATS) and the IEEE Asian Test Symposium (ATS). At each semi-final, a jury composed of academia and industrial experts will determine the winner, and the four winners will compete against each other in the finals, held at the International Test Conference (ITC) 2025.
      <br><br>All four semi-final sites are seeking submissions from active doctoral students working on test-related topics. Prospective participants are encouraged to participate when they are close to thesis completion and have obtained sufficient results.
      <br><br>We are inviting submissions for the 26th IEEE Latin-American Test Symposium - LATS 2025 semi-final to be held in San Andrés Island, Colombia, 11th - 14th March 2025.
      </base-section-heading>
    <base-section-heading
    title="Eligibility"
    color="secondary"
    align="left"
    :toColor="true"
    >
    •	Doctoral students working on test-related topics are eligible for the award.<br>
•	Eligible students are those who graduated starting from April 2023 up to 2025.<br>
•	An individual can only participate in the contest <strong>once in a lifetime</strong> (participation is encouraged when the thesis is close to completion).<br>
•	<strong>Submissions to multiple regional sites are prohibited.</strong><br>

      </base-section-heading>
    <base-section-heading
    title="Procedure"
    color="secondary"
    align="left"
    :toColor="true"
    >
    Prospective contestants submit a summary of their thesis work (up to 2000 words), possibly accompanied by one additional page of figures and references. They are free to submit up to three published references as supporting material, which are considered by the jury on an optional basis.
    <br><br> The abstract should clearly address the following:
    <br>●	define the problem and its relevance to industry,<br>
●	describe existing industrial practices for solving the problem, and<br>
●	explain the proposed methodology (and any pertinent case study) and how it advances the theory and/or practice in the field.

      <br><br> The submissions must follow the template available in:
      <br><br>
      <v-btn
        href="https://docs.google.com/document/d/1TrEeOUKyWdztp_NituFjJLtIwf72I6hI/edit?usp=sharing&ouid=101364459774283052171&rtpof=true&sd=true"
        target="_blank"
        rounded
        color="primary"
        dark
        style="padding: 15px"
      >
        <v-icon
          left
          dark
        >
          mdi-open-in-new
        </v-icon>
        Link to the McCluskey template
      </v-btn>
      <br><br> <strong>Please access the link and download the file to edit the document.</strong>
      <br><br> Selected contestants will be given a short presentation slot in a designated technical session. The presentation is expected to be in person, in the program of the LATS 2025 event.  The winner will be determined by the jury and announced during the LATS2025.
      <br><br> Semi-finals could be cancelled if the number of submissions is inadequately low, in which case candidates will be invited to take part in another semi-final.
    </base-section-heading>

      <base-section-heading
    title="Key Dates"
    color="secondary"
    align="left"
    :toColor="true"
    >
      <v-data-table
        :headers="headers"
        :items="dates"
        :items-per-page="-1"
        item-key="name"
        hide-default-footer
        class="elevation-1"
      >
        <template v-slot:[`item.date`]="{ item }">
          <span
          v-html="item.date"
          >
          </span>
        </template>
      </v-data-table>
      </base-section-heading>
          <base-section-heading
    title="Submission Website"
    color="secondary"
    align="left"
    :toColor="true"
    >
      Submissions should be made electronically as a single PDF file via Easy chair.
      <br><br>
<v-btn
  href="https://easychair.org/conferences/?conf=lats2025"
  target="_blank"
  rounded
  color="primary"
  dark
  download
  style="padding: 15px"
>
  <v-icon
    left
    dark
  >
    mdi-open-in-new
  </v-icon>
  Link to the Sumissions website
</v-btn>
      </base-section-heading>
<base-section-heading
    title="Contacts"
    color="secondary"
    align="left"
    :toColor="true"
    >
    For more information, please contact the LATS2025 vice-program chair Cristina Meinhardt (<a href="mailto:cristina.meinhardt@ufsc.br">cristina.meinhardt@ufsc.br</a>).
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Mccluskey',

    data: () => ({
      isMobile: false,
      headers: [
        {
          text: 'Type',
          value: 'name',
          sortable: false,
          align: 'left',
        },
        {
          text: 'Deadline Date',
          value: 'date',
          sortable: false,
          align: 'left',
        },
      ],
      dates: [
        {
          name: 'McCluskey submissions',
          date: '<strong>24 January 2025</strong>',
        },
        {
          name: 'Notification of acceptance',
          date: '<strong>10 February 2025</strong>',
        },
      ],
    }),
    mounted () {
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
<style>
.btn-multiline > span {
  width: 100%
}
</style>
